module.exports = __webpack_public_path__ + "static/media/b0_p14_clickable.cc768a55.png";